import deepEqual from 'deep-equal';
import { rolloverTypes } from '../../shared/utils';
import { IRAAccountTypes } from '../../transfer-flows/loaders';
import { isEmptyObject } from '../../../core/util';

export const getApplicationType = (toIRAAccountType): string => {
  if (toIRAAccountType) {
    return `: ${toIRAAccountType}`;
  }
  return '';
};

export const getCusip = (cusipsArr, idx): any => {
  return cusipsArr.find((_, index) => index === idx);
};

export const convertFONASUCustomerCitizenshipType = (type): string =>
  ({
    C: 'US_CITIZEN',
    R: 'RESIDENT_ALIEN',
    N: 'NON_RESIDENT_ALIEN'
  }[type] || 'US_CITIZEN');

export const convertFONASUCustomerPhoneNumbers = (phoneNumbers): Array<any> => {
  let phones = [
    {
      areaCode: '',
      exchange: '',
      lastFour: '',
      type: ''
    }
  ];
  if (phoneNumbers && phoneNumbers.length > 0) {
    phones = phoneNumbers.map(phone => ({
      areaCode: phone.areaCode,
      exchange: phone.exchange,
      lastFour: phone.localNumber,
      type:
        phone.phoneNumberType === 'cellular'
          ? 'MOBILE'
          : phone.phoneNumberType.toUpperCase()
    }));
  }
  return phones;
};

export const getRolloverCustodianInfo = (rolloverType, custodian): any => {
  const { custodianID, custodianName } = custodian;
  if (rolloverType === rolloverTypes.DIRECT) {
    return {
      custodianID,
      custodianName
    };
  }
  return {
    custodianID: '',
    custodianName: ''
  };
};

export const rpsAccountTypes = {
  OMNI: 'OCR_OMNI',
  TRAC: 'OCR_TRAC',
  ROTH_ROLLOVER_OMNI: 'ROTH_ROLLOVER_OMNI',
  ROTH_ROLLOVER_TRAC: 'ROTH_ROLLOVER_TRAC'
};

export const rpsFundingTypes = {
  EXISTING_ONLY: 'EXISTING_ONLY',
  EXISTING_AND_NEW: 'EXISTING_AND_NEW',
  NEW: 'NEW'
};

export const ocrRolloverAmountOptions = {
  PERCENTAGE: 'Percentage',
  DOLLAR: 'Dollar',
  ALL: 'Full-Amount'
};

export const rpsDeliveryMethodTypes = {
  USPS: 'USPS',
  DOCUSIGN: 'ELECTRONIC_SIGNATURE'
};

export const isCurrentAndPriorYearAmount = (
  currentYearAmount,
  priorYearAmount
): boolean => currentYearAmount && priorYearAmount;

export const isRPSOCRTraditionalAccount = (accountType): boolean =>
  accountType === rpsAccountTypes.OMNI || accountType === rpsAccountTypes.TRAC;

export const isRPSOCROmniAccount = (accountType): boolean =>
  accountType === rpsAccountTypes.OMNI ||
  accountType === rpsAccountTypes.ROTH_ROLLOVER_OMNI;

export const isRPSOCRAccount = (accountType): boolean => {
  if (
    [
      rpsAccountTypes.OMNI,
      rpsAccountTypes.TRAC,
      rpsAccountTypes.ROTH_ROLLOVER_OMNI,
      rpsAccountTypes.ROTH_ROLLOVER_TRAC
    ].includes(accountType)
  )
    return true;

  return false;
};

export const rpsBeneficiaryCatogories = {
  INDIVIDUAL: 'INDIVIDUAL',
  ENTITY: 'ENTITY'
};

export const rpsBeneficiaryTypes = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};

export const beneFilterByType = (beneArray, type): any => {
  return beneArray?.filter(beneInfo => beneInfo.beneficiaryType === type);
};

export const getFONASUTransferRJProgressStep = (fromIRAAccountType): string => {
  switch (fromIRAAccountType) {
    case IRAAccountTypes.ROTH:
      return '87bcf3';
    case IRAAccountTypes.ROLLOVER:
      return 'bec356';
    case IRAAccountTypes.SEP:
      return '19ce7e';
    default:
      return '9ca4d2';
  }
};

export const isOCRExistingAgreementsEditable = (
  loadedData,
  accountType
): boolean =>
  isRPSOCRAccount(accountType) &&
  loadedData.existingAgreementsEditMode !== undefined &&
  loadedData.existingAgreements?.length > 0;

export const isMailingAddressDifferent = (customerDataConverted): boolean => {
  // DE50048 set mailingAddressDifferent as true only when secondary address is
  // present and its not same as primaryAddress
  const mailingAddressDifferent =
    !isEmptyObject(customerDataConverted?.mailingAddress) &&
    !deepEqual(
      customerDataConverted?.residentialAddress,
      customerDataConverted?.mailingAddress
    );
  return mailingAddressDifferent;
};
